// frontend/src/services/api.ts
import axios from 'axios'
import { domainConfig } from '../utils/domainConfig'

export interface CommonResponse {
  statusCode: number
  message: string
  data: any
}

// Use domain-based API URL configuration
// API calls will use the same domain the user accessed
const api = axios.create({
  baseURL: domainConfig.apiBaseUrl,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 10000 // Request timeout (10 seconds)
})

export default api

